// The field contains an episode number or "trailer". The API still receives
// canonical MP4 import names, while original S3 paths identify the files.
export function episodeValue(file) {
    if (file.kind === 'trailer' || (!file.invalidName && /trailer/i.test(file.reason || ''))) return 'trailer';
    return file.episodeNumber == null ? '' : String(file.episodeNumber).padStart(2, '0');
}

// Describe gaps without allocating every missing number in a large range.
export function missingEpisodeRanges(values) {
    const numbers = [...new Set(values.filter((n) => Number.isInteger(n) && n > 0))].sort((a, b) => a - b);
    const missing = [];
    for (let i = 1; i < numbers.length; i += 1) {
        const first = numbers[i - 1] + 1;
        const last = numbers[i] - 1;
        if (first <= last) missing.push(first === last ? String(first) : `${first}–${last}`);
    }
    return missing;
}

export function renamedFile(file, name) {
    const cleaned = name.trim();
    if (/^trailer$/i.test(cleaned)) {
        return { ...file, kind: 'trailer', episodeNumber: undefined, reason: undefined, invalidName: false };
    }
    const number = cleaned.match(/^(0*[1-9]\d*)$/)?.[1];
    if (number && Number(number) <= 2147483647) {
        return { ...file, kind: 'episode', episodeNumber: Number(number), reason: undefined, invalidName: false };
    }
    return { ...file, kind: 'skipped', episodeNumber: undefined, invalidName: true,
        reason: 'Enter an episode number such as 01, or trailer.' };
}

// Assign consecutive numbers in the visible row order. Trailers and unticked
// files do not consume a number; keep the first selected episode as the start.
export function renumberInOrder(files, renames, picked) {
    const episodes = files.filter((file) => file.isMp4 && picked.has(file.name) && episodeValue(file) !== 'trailer');
    const first = episodes[0]?.episodeNumber;
    if (!Number.isInteger(first) || first < 1 || first + episodes.length - 1 > 2147483647) return null;
    const next = { ...renames };
    episodes.forEach((file, index) => { next[file.name] = String(first + index).padStart(2, '0'); });
    return next;
}
